// src/components/shared/LoadingState.jsx
import React, { memo } from 'react';
import { Loader2 } from 'lucide-react';
import PropTypes from 'prop-types';

/**
 * Standardized loading state component.
 * Replaces inline loading spinners with consistent UX.
 * Memoized to prevent unnecessary re-renders.
 *
 * Usage:
 * <LoadingState message="Loading analytics..." size={60} />
 * <LoadingState /> // Uses defaults
 */
const LoadingState = memo(function LoadingState({ message = 'Loading...', size = 40, minHeight = 200 }) {
  const heightStyle =
    typeof minHeight === 'number' ? { minHeight: `${minHeight}px` } : { minHeight };

  return (
    <div
      className="flex flex-col items-center justify-center gap-4"
      style={heightStyle}
    >
      <Loader2
        className="animate-spin text-primary"
        style={{ width: size, height: size }}
        aria-hidden="true"
      />
      {message && <p className="text-sm text-muted-foreground">{message}</p>}
    </div>
  );
});

LoadingState.propTypes = {
  message: PropTypes.string,
  size: PropTypes.number,
  minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default LoadingState;
